<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <vx-card>
        <vs-table pagination :max-items="maxItem" search :data="transactionLogs">

          <template slot="header">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">{{ $t("sections.system.dataForm.limit", {maxItem, total: transactionLogs.length}) }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="maxItem = value" :key="i" v-for="(value, i) in maxItemsOption">
                    <span>{{ value }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </template>
          <template slot="thead">
            <vs-th sort-key="email">{{ $t("sections.system.dataForm.account.email") }}</vs-th>
            <vs-th sort-key="createdAt">{{ $t("sections.system.dataForm.createdAt") }}</vs-th>
            <vs-th sort-key="isAction">{{ $t("sections.system.dataForm.isAction") }}</vs-th>
            <vs-th sort-key="method">{{ $t("sections.system.dataForm.method") }}</vs-th>
            <vs-th sort-key="type">{{ $t("sections.system.dataForm.type") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.account.email">
                {{ tr.account.email }}
              </vs-td>
              <vs-td :data="tr.createdAt">
                {{ setMoment(tr.createdAt) }}
              </vs-td>
              <vs-td :data="tr.action">
                {{ tr.action }}
              </vs-td>
              <vs-td :data="tr.method">
                {{ tr.method }}
              </vs-td>
              <vs-td :data="tr.type">
                {{ tr.type }}
              </vs-td>

              <template slot="expand">
                <div class="w-full">
                  <pre>{{ tr.payload | pretty }}</pre>
                </div>
              </template>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
const {mapActions: mapSystemActions, mapState: mapSystemState } = createNamespacedHelpers('System')

export default {
  data () {
    return {
      maxItem: 10,
      maxItemsOption: [5, 10, 20, 100],
    }
  },
  filters: {
    pretty: function(value) {
      return JSON.stringify(JSON.parse(value), null, 2);
    }
  },
  async created () {
    await this.getTransactionLogs()
    this.pms ('SystemTransactionLog', 'visible', 'r')
  },
  computed: {
    ...mapSystemState(['transactionLogs', 'status'])
  },
  methods: {
    ...mapSystemActions(['getTransactionLogs']),
    setMoment(datetime){
      return moment(datetime).format()
    },
    setMomentFromNow(datetime){
      return moment(datetime).startOf('minute').fromNow();
    }
  }
}
</script>
